<style lang="less" rel="stylesheet/less" scope>
  @import url('./../css/common.less');
  .login-wrapper {
    .canvas {
      .canvas-content {
        opacity: 1;
        background: url(../../../assets/login/login_blue.jpg) 100% 100% no-repeat;
        z-index: -1;
      }
    }
    .el-form {
      background-color: #fff;
    }
    footer {
      ul {
        li {
          color: #fff;
        }
      }
    }
  }
</style>
<template>
  <div class="login-wrapper" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.2)">
    <div class="canvas">
      <div class="canvas-content">
      </div>
    </div>
    <div v-show="!isLoading" class="login-wrapper-content">
      <header>
        <p class="blue">{{title}}</p>
      </header>
      <section ref="section">
        <el-row class="main-row">
          <el-col>
            <login-board ref="login" styleColor="blue"></login-board>
          </el-col>
        </el-row>
      </section>
      <footer class="effect">
        <ul>
          <li>
            <span class="footer-item techSupport" v-show="competentData.techSupport">技术支持：
               <a class="info" :href='competentData.techSupportLink'  :class="{'foot-hover':competentData.techSupportLink}" target="_blank">{{competentData.techSupport}}</a>
            </span>
            <span class="footer-item customerTelephone" v-show="competentData.customerTelephone">客服电话：
              <a target="_blank">{{competentData.customerTelephone}}</a>
            </span>
            <span class="other-item" v-if="otherConfig&&otherConfig.webNumber">网站备案号：{{otherConfig.webNumber}}</span>
          </li>
        </ul>
      </footer>
      <ly-customer-board class="customer"></ly-customer-board>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import { asyncLoadJs } from '@/utils/asyncLoad';
  import loginBoard from './login.vue'
  import { getIndex } from '@/api/login'
  export default {
    name: 'login',
    components: {
      loginBoard
    },
    data () {
      return {
        loading: true,
        isLoading: true,
        BASE_API: this.$store.getters.objApi.BASE_API,
        title: '联羿图书馆管理云平台',
        competentData: {
          showDefaultCenter: false,
          showDefaultHeader: false
        },
        active: 0,
        clientHeight: 2000,
        clientWidth: 2000,
        seen:false
      }
    },
    computed: {
      imgCarousel() {
        return this.competentData.centerImgUrl ? this.competentData.centerImgUrl.split(',') : [];
      },
      otherConfig() {
        return this.$store.getters.objApi.otherConfig
      },
      rule(){
        return this.$store.getters.objApi.rule
      },
      objApi() {
        return this.$store.getters.objApi
      }
    },
    created() {
      this.getIndex();
      this.clientWidth = document.documentElement.clientWidth || document.body.clientWidth;
      this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight
      asyncLoadJs(this.objApi.LOCAL_URL + '/static/vendor/jquery/dist/jquery.min.js').then(() => {
        $('.canvas-content').width(this.clientWidth);
        $('.canvas-content').height(this.clientHeight);
      });
    },
    mounted() {
      
      this.$nextTick(() => {
        setTimeout(()=>{
          this.loadImg();
          window.onresize = () => {
            this.setLogin();
          };
        },0);
        setTimeout(() => {
          this.loading = false;
          this.isLoading = false;
        }, 100)
      })
    },
    methods: {
      visible:function () {
        this.seen=true;
      },
      display:function () {
        this.seen=false;
      },
      setLogin() {
//        let $login = this.$refs.login.$el;
//        $login.setAttribute('style', 'height:' + (this.$refs.section.clientHeight - 56) + 'px');
      },
      loadImg() {
        let _this = this;
        // document.getElementById('img1').onload = () => {
        //   _this.setLogin();
        //   _this.isLoading = false;
        //   _this.loading = false;
        // }
      },
      getIndex() {
        getIndex().then(res => {
          this.competentData = res.data;
          if(!this.competentData.centerImgUrl){
            this.competentData.showDefaultCenter = true;
          }
          if(!this.competentData.logoImgUrl){
            this.competentData.showDefaultHeader = true;
          }
          this.isLoading = false;
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/login/components/index-blue.vue